export const getBusinessApiKeysUrl = () => '/business/api_keys';

export const getBusinessApiKeyUrl = (id: number | string) => `/business/api_keys/${id}`;

export const getBusinessApiKeyNewUrl = () => '/business/api_keys/new';
